import { render } from "./ProductDashboard.vue?vue&type=template&id=4b74a808&scoped=true"
import script from "./ProductDashboard.vue?vue&type=script&lang=js"
export * from "./ProductDashboard.vue?vue&type=script&lang=js"

import "./ProductDashboard.vue?vue&type=style&index=0&id=4b74a808&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b74a808"]])

export default __exports__